import {
  FETCH_BFS_FOR_SELLER_SHIPMENT_DATA_REQUEST,
  FETCH_BFS_FOR_SELLER_SHIPMENT_DATA_SUCCESS
} from "../../constants/sellers";
import { createReducer } from "../../utils";

const initialState = {
  isFetching: true,
  sellerAddress: {},
  buyerfulfilments: [],
  page: 1,
  count: 0,
  isAllChecked: false
};

export const sellerShipmentsReducer = createReducer(initialState, {
  [FETCH_BFS_FOR_SELLER_SHIPMENT_DATA_SUCCESS]: (state, payload) => {
    return {
      ...state,
      ...payload,
      isFetching: false
    };
  },
  [FETCH_BFS_FOR_SELLER_SHIPMENT_DATA_REQUEST]: (state, payload) => {
    return {
      ...state,
      ...payload,
      isFetching: true
    };
  }
});

export default sellerShipmentsReducer;
